import axios from '../../services/axios';

function loadAllProducts() {
  return axios({
    method: 'GET',
    url: '/regimen_finder/all_products/',
  });
}

function loadSkincareProducts() {
  return axios({
    method: 'GET',
    url: '/regimen_finder/skincare_products/',
  });
}

function loadBoughtProductIds() {
  return axios({
    method: 'GET',
    url: '/regimen_finder/bought_product_ids/',
  });
}

function loadProductsTaggings() {
  return axios({
    method: 'GET',
    url: '/regimen_finder/products_taggings/',
  });
}

function sendEmail(variantIds, email) {
  return axios.post('/regimen_finder/send_email/', { variant_ids: variantIds, email });
}

function saveRegimen(params) {
  return axios.post('/regimen_finder/', params);
}

const api = {
  loadAllProducts,
  loadProductsTaggings,
  sendEmail,
  saveRegimen,
  loadBoughtProductIds,
  loadSkincareProducts,
};

export default api;
